export default "__VITE_PUBLIC_ASSET__6b0e76b4__"